import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventDeviceInsight } from '@onefootprint/request-types/dashboard';
import useEntityDeviceInsights from '@/components/entities/components/details/hooks/use-entity-device-insights';
import useEntityId from '@/components/entities/components/details/hooks/use-entity-id';
export const useOpenDatadog = () => {
  const $ = _c(9);
  const entityId = useEntityId();
  const {
    data,
    isPending,
    isError
  } = useEntityDeviceInsights(entityId);
  let t0;
  if ($[0] !== data?.data) {
    const sessionIds = data?.data.filter(_temp)?.map(_temp2).filter(_temp3);
    t0 = new Set(sessionIds);
    $[0] = data?.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = [...t0];
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const uniqueSessionIds = t1;
  let t2;
  if ($[4] !== uniqueSessionIds) {
    t2 = () => {
      const sessionIdsStr = uniqueSessionIds?.join(" OR ");
      const thirtyDaysAgo = Date.now() - 2592000000;
      const url = `https://app.datadoghq.com/logs?query=@fp_session_id:(${sessionIdsStr})&from_ts=${thirtyDaysAgo}`;
      window.open(url);
    };
    $[4] = uniqueSessionIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const openDatadog = t2;
  const t3 = !isPending && !isError && !!uniqueSessionIds?.length;
  let t4;
  if ($[6] !== openDatadog || $[7] !== t3) {
    t4 = {
      isEnabled: t3,
      openDatadog
    };
    $[6] = openDatadog;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(e) {
  return e.event.kind === "device_insight";
}
function _temp2(e_0) {
  return (e_0.event as UserTimelineEventDeviceInsight).data.insight.sessionId;
}
function _temp3(sessionId) {
  return !!sessionId;
}